import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import theme from '../../theme';

const ModalFooter = ({
  isLoading,
  inputErrorMsg,
  modalContent,
  modalData,
  setModalData,
  handleModalSubmit,
  handleClose
}) => {

  return (
    <>
      <Stack
        variant='center-center'
        sx={{ 
          paddingTop: '16px',
          paddingBottom: '32px'
        }}
      >
        <Stack>
          {
            modalContent.cancelTxt &&
            <Button
              variant="text-cancel"
              disabled={isLoading}
              onClick={handleClose}
            >
              {modalContent.cancelTxt}
            </Button>
          }
          {
            modalContent.submitTxt &&
            <Button
              variant="contained"
              color={modalContent.submitTxt === "刪除" ? "error" : "primary"}
              disabled={isLoading}
              endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
              onClick={() => handleModalSubmit(modalData, modalContent.name )}
              sx={{
                color: "#fff"
              }}
            >
              {modalContent.submitTxt}
            </Button>
          }
        </Stack>
      </Stack>
    </>
  )
}

export default ModalFooter;